import Vue from 'vue'
import Vuex from 'vuex'

import mutations from "./mutations"
import getters from './getters'
import moduleA from './modules/moduleA'
import user from './modules/user'
//挂载Vuex
Vue.use(Vuex)

const state = {
    isActive:false,// 基础数据-检查表模板选中显示
}

//创建VueX对象
const store = new Vuex.Store({
    // state:{
    //     //存放的键值对就是所要管理的状态
    //     userId:'安全信息分类'
    // },
    // mutations:{
    //     //es6语法，等同edit:funcion(){...}
    //     edit(state,payload){
    //         state.userId = payload
          
    //     }
    // }
    state,
    mutations:mutations,
    actions: {
        asupdateInfo(context, payload){
          return new Promise((resolve, reject) =>{
            setTimeout(() => {
              context.commit({
                type: 'updateAge',
                age: payload.age
              })
              resolve(`修改age为 ${payload.age} 成功`)
            },2000)
          })
        }
      },
      modules: {
        user
      }

})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js